import type { ICustomSegmentsMetaData } from "app/services/segments/segmentsApiService";
import { EMPTY_CUSTOM_SEGMENTS } from "app/services/segments/segmentsApiService";
import { SwRedux } from "app/services/SwRedux";

export enum SegmentType {
    MySegment = "my segment",
    AccountSegment = "account segment",
}

export const resolveSegmentType = (
    segmentId: string,
    segmentsModuleOverride?: {
        customSegmentsMeta?: ICustomSegmentsMetaData;
    },
): SegmentType | undefined => {
    const swRedux = SwRedux.getInstance();
    const { segmentsModule } = swRedux.getState();
    const { customSegmentsMeta = EMPTY_CUSTOM_SEGMENTS } = segmentsModuleOverride ?? segmentsModule ?? {};
    const { Segments: userSegments = [], AccountSegments: accountSegments = [] } = customSegmentsMeta;
    const predicate = (segment) => segment.id === segmentId;

    const userSegment = userSegments.find(predicate);
    if (userSegment) {
        return SegmentType.MySegment;
    }

    const accountSegment = accountSegments.find(predicate);
    if (accountSegment) {
        return SegmentType.AccountSegment;
    }
};
